module.exports = __webpack_public_path__ + "img/quicktips16.261391d9.svg";